import React from 'react';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'dayjs/locale/ko';
import 'swiper/css';
import BadgeItem from './../../../Components/Ui/BadgeItem';
import Icon from '../../../Assets/Icon/CustomIcon';

/** 홈 공지 NEW — 중요(빨강)와 구분, 사업장/부서와 같은 파스텔 톤 */
const HOME_NEW_BADGE_CLASS = '!bg-violet-50 !text-violet-600 !shadow-none';

export default function Notice() {
  const { navigate } = useAppNavigate();
  const { noticeData } = useSelector((state) => state.homeInfo);

  const validNoticeData =
    noticeData?.filter((item) => item.title && item.title.trim() !== '') || [];

  const isNewNotice = (item) =>
    String(item?.newYn ?? 'N').toUpperCase() === 'Y';

  const canLoop = validNoticeData.length > 1;

  return (
    <div className="flex w-full min-w-0 flex-col gap-4">
      <div className="mb-2 w-full min-w-0 overflow-hidden rounded-lg border border-slate-50 shadow-sm">
        {validNoticeData.length === 0 ? (
          <div
            className="w-full bg-white px-4 py-5 text-center text-[14px] text-slate-400"
            onClick={() => {
              navigate(`/M_Notice`);
            }}
          >
            등록된 공지사항이 없습니다.
          </div>
        ) : (
          <Swiper
            slidesPerView={1}
            autoplay={
              canLoop ? { delay: 3000, disableOnInteraction: false } : false
            }
            className="w-full max-w-full overflow-hidden"
            loop={canLoop}
            modules={[Autoplay]}
          >
            {validNoticeData.map((item, index) => (
              <SwiperSlide key={index} className="!w-full max-w-full">
                <div
                  className="transition-active flex w-full min-w-0 cursor-pointer items-center gap-2 bg-white p-3"
                  onClick={() => {
                    navigate('/M_Notice');
                  }}
                >
                  <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
                    {item?.noticeYn === 'Y' && (
                      <BadgeItem
                        type="중요"
                        label="중요"
                        className="shrink-0"
                      />
                    )}
                    <BadgeItem
                      type={item?.gubunNm}
                      label={item?.gubunNm}
                      className="shrink-0"
                    />
                    <p className="min-w-0 flex-1 truncate text-xs font-medium text-slate-700">
                      {item.title}
                    </p>
                  </div>
                  <div className="flex shrink-0 items-center gap-1.5 text-slate-300">
                    {isNewNotice(item) && (
                      <BadgeItem
                        type="NEW"
                        label="NEW"
                        className={HOME_NEW_BADGE_CLASS}
                      />
                    )}
                    <Icon.ChevronRight />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
}
